import React from 'react';

interface Props {}

const SecondStep: React.FC<Props> = () => {
  return <div></div>;
};
SecondStep.displayName = 'SecondStep';

export default SecondStep;
